import React, { useState } from 'react';
import { Box } from '@mui/material';

import { getAllAnnotationTemplates, getSortedTemplateGroupNames } from '../../../selectors/annotationTemplates';
import { useAppSelector } from '../../hooks';
import GroupSelect from './GroupSelect';
import TemplateList from './TemplateList';

interface Props {
  templates: any[];
  selectedTemplate: number;
  onSelectTemplate: (template: any) => void;
}

export default function TemplateDirectory(props: Props) {
  const { selectedTemplate, onSelectTemplate } = props;
  const allTemplates = useAppSelector(getAllAnnotationTemplates);
  const sortedGroupNames = useAppSelector(getSortedTemplateGroupNames);

  const [selectedGroup, setSelectedGroup] = useState<string | null>(null);

  const templates =
    selectedGroup === null ? allTemplates : allTemplates.filter((template) => template.group === selectedGroup);

  return (
    <Box sx={{ mt: 2, width: '100%', maxWidth: 360 }}>
      <GroupSelect groups={sortedGroupNames} selectedGroup={selectedGroup} onSelectGroup={setSelectedGroup} />

      <TemplateList
        sx={{
          mt: 3,
          maxHeight: '50vh',
          overflowY: 'hidden',
          overflowx: 'hidden',
          '&:hover': {
            overflowY: 'auto',
          },
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
          bgcolor: 'backContrast.main',
        }}
        templates={templates}
        selectedTemplateId={selectedTemplate}
        onSelectTemplate={onSelectTemplate}
      />
    </Box>
  );
}
